import { Container } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { n95FitFormFields } from "../../../services/formFields";
import NavigationButtons from "./components/navigationButtons";
import TextAreaReligious from "./components/textAreaReligious";
import TextAreaReligiousAdditionalInfo from './components/textAreaReligiousAdditionalInfo';
import useFormSubmit from "./components/useFormSubmit";

const schema = yup.object({
    [n95FitFormFields.religiousBeliefN95.key]: yup.string().required('This field must be filled'),
    [n95FitFormFields.howReligiousBeliefRestrictsN95.key]: yup.string().required('This field must be filled'),
    [n95FitFormFields.howReligiousBeliefPreventsN95.key]: yup.string().required('This field must be filled')
});


export default function RelN95FitForm({ exemptionType, requestId, fieldsJSON, moreInfoFieldsJSON }) {
    const defaultValues = fieldsJSON;
    const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema),defaultValues });
    const onSubmit = useFormSubmit(exemptionType, requestId);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Container className="mt-1 mt-md-5">
                <TextAreaReligious
                    defaultValues={defaultValues}
                    id={n95FitFormFields.religiousBeliefN95.key}
                    labelText={n95FitFormFields.religiousBeliefN95.label}
                    register={register}
                    errors={errors}
                    showIsRequired />

                <TextAreaReligious
                    defaultValues={defaultValues}
                    id={n95FitFormFields.howReligiousBeliefRestrictsN95.key}
                    labelText={n95FitFormFields.howReligiousBeliefRestrictsN95.label}
                    register={register}
                    errors={errors}
                    showIsRequired />

                <TextAreaReligious
                    defaultValues={defaultValues}
                    id={n95FitFormFields.howReligiousBeliefPreventsN95.key}
                    labelText={n95FitFormFields.howReligiousBeliefPreventsN95.label}
                    register={register}
                    errors={errors}
                    showIsRequired />

                <TextAreaReligiousAdditionalInfo moreInfoRequest={moreInfoFieldsJSON} register={register} errors={errors} />

            </Container>
            <NavigationButtons />
        </form>
    );
}
